import React, { createContext, useState, useContext } from 'react';

// Create a context for the mobile menu
const MobileMenuContext = createContext();

// Provider component that will wrap the mobile menu components
export const MobileMenuProvider = ({ children }) => {
  // Keep track of which menu is currently open
  const [openMenuId, setOpenMenuId] = useState(null);

  // Function to toggle a menu open/closed
  const toggleMenu = (menuId) => {
    if (openMenuId === menuId) {
      // If clicking the currently open menu, close it
      setOpenMenuId(null);
    } else {
      // Otherwise open the new menu (this will close any other open menu)
      setOpenMenuId(menuId);
    }
  };

  // Context value to be provided
  const contextValue = {
    openMenuId,
    toggleMenu,
  };

  return (
    <MobileMenuContext.Provider value={contextValue}>
      {children}
    </MobileMenuContext.Provider>
  );
};

// Custom hook to easily access the mobile menu context
export const useMobileMenu = () => {
  const context = useContext(MobileMenuContext);
  if (!context) {
    throw new Error('useMobileMenu must be used within a MobileMenuProvider');
  }
  return context;
};